import { useLang } from "../LanguageContext";
import { translations } from "../data/translations";
import { ChevronDown } from "lucide-react";
import { motion } from "framer-motion";

export default function Hero() {
  const { lang } = useLang();
  const t = translations[lang] || translations.de;

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden text-white"
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_rgba(37,99,235,0.35),_transparent_35%),radial-gradient(circle_at_bottom_left,_rgba(59,130,246,0.22),_transparent_35%),linear-gradient(180deg,#0a2347_0%,#0b3f8a_55%,#0a2d63_100%)]" />

      <div
        className="absolute inset-0 opacity-15"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg width='60' height='69' viewBox='0 0 60 69' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' stroke='white' stroke-opacity='0.18' stroke-width='1'%3E%3Cpath d='M30 1l29 17v33L30 68 1 51V18z'/%3E%3C/g%3E%3C/svg%3E\")",
          backgroundSize: "60px 69px",
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="flex flex-col items-center"
        >
          <img
            src="/images/logo-fumda.png"
            alt="Fumda"
            className="w-[320px] md:w-[520px] lg:w-[700px] xl:w-[820px] h-auto mb-4 opacity-70 drop-shadow-[0_12px_40px_rgba(0,0,0,0.35)]"
          />

          <p className="text-lg md:text-2xl text-white/85 mb-8 max-w-3xl mx-auto">
            {t.hero?.subtitle || "Professionelle Rackmount- und Tower-Serverlösungen"}
          </p>

          <a
            href="#products"
            className="inline-flex items-center gap-2 px-8 py-4 bg-brand-blue hover:bg-blue-700 text-white rounded-lg font-semibold transition shadow-lg"
          >
            {t.hero?.cta || "Produkte entdecken"}
            <ChevronDown className="w-5 h-5" />
          </a>
        </motion.div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce z-10">
        <ChevronDown className="w-8 h-8 text-white/50" />
      </div>
    </section>
  );
}
